<template>
  <div class="main_component">
    <!-- Mostrar un spinner mientras las imágenes están cargando -->
    <v-progress-circular 
      v-if="isLoading" 
      indeterminate 
      color="primary" 
      size="64" 
      class="loading-spinner"
    ></v-progress-circular>

    <!-- Mostrar el carrusel solo si las imágenes están cargadas -->
    <v-carousel v-else hide-delimiters cycle :interval="8000">
      <v-carousel-item
        v-for="(item, i) in listNoticias"
        :key="i"
        class="git_intro"
      >
        <a :href="item.link_img" target="_blank">
          <img :src="item.url_img" class="carousel-image" />
        </a>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { CarruselService } from "@/services/CarruselService.js";

export default {
  name: 'MainScreenView',
  data() {
    return {
      listNoticias: [],
      isLoading: true,  // Estado de carga
    };
  },
  beforeMount(){
    this.getNoticias();
  },
  methods:{
    getNoticias: async function (){     
      await CarruselService.getImages().then((resp) => {
        if (!resp.error) {
          this.listNoticias = resp.response;
          this.isLoading = false; // Las imágenes han cargado, quitamos el spinner
        } else {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: resp.msg,
          };
        }
      }).catch(error =>{
        console.log("ERROR: Obtener imagenes, ", error);
        this.isLoading = false;  // En caso de error también quitamos el spinner
      })
    },
  }
}
</script>

<style scoped>
.main_component {
  width: 100%;
  height: 100vh; /* Altura completa de la ventana */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden; /* Evitar scroll si el contenido desborda */
}


/* Estilos del spinner de carga */
.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.git_intro {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 100%;
}

.carousel-image {
  padding-left: 12%;
  padding-top: 2%;
  max-width: 90%;
  max-height: 100%;
  width: 90%;
  height: auto;
  object-fit: cover;
}
</style>
